<div class="sem-geo-map">
  @if (configurationError) {
    <div class="sem-geo-map-message sem-geo-map-message-error">{{ configurationError }}</div>
  } @else {
    @if (bindingWarning) {
      <div class="sem-geo-map-message sem-geo-map-message-error">{{ bindingWarning }}</div>
    }

    <div class="sem-geo-map-frame" [class.sem-geo-map-frame-editing]="isEditModeEnabled">
      <div #mapHolder class="sem-geo-map-holder" [style.height]="mapHeightPx"></div>

      @if (isEditModeEnabled) {
        <div class="sem-geo-map-edit-mode-notch">Edit mode on</div>
      }

      @if (showEditModeToggle) {
        <button
          type="button"
          class="sem-geo-map-edit-toggle"
          [class.sem-geo-map-edit-toggle-active]="isEditModeEnabled"
          [attr.aria-label]="isEditModeEnabled ? 'Exit map edit mode' : 'Edit map pins'"
          [attr.title]="isEditModeEnabled ? 'Exit edit mode' : 'Edit pins'"
          (click)="toggleEditMode()">
          <span class="material-symbols-outlined">{{ isEditModeEnabled ? 'open_with' : 'edit_location_alt' }}</span>
        </button>
      }

      @if (showPinEditor) {
        <section class="sem-geo-map-popup-editor" aria-label="Edit pin">
          <div class="sem-geo-map-popup-editor-header">
            <div class="sem-geo-map-popup-editor-pin-title">
              <span>Editing pin</span>
              <strong>{{ selectedPinTitle }}</strong>
            </div>
            <button
              type="button"
              class="sem-geo-map-popup-editor-close"
              title="Close"
              aria-label="Close pin editor"
              (click)="closePinEditor()">
              <span class="material-symbols-outlined">close</span>
            </button>
          </div>

          @if (showPinTitle) {
            <label class="sem-geo-map-popup-editor-title-input">
              <span>Pin title</span>
              <input
                type="text"
                placeholder="Pin title"
                [value]="selectedPinTitleValue"
                (input)="updateSelectedPinTitle($event)">
            </label>
          }

          @if (showPinDescription) {
            <label class="sem-geo-map-popup-editor-note-input">
              <span>Description</span>
              <textarea
                rows="2"
                placeholder="Description"
                [value]="selectedPinDescriptionValue"
                (input)="updateSelectedPinDescription($event)"></textarea>
            </label>
          }

          @if (showPopupFields) {
            <div class="sem-geo-map-popup-editor-fields">
              @for (field of selectedPopupFields; track $index; let fieldIndex = $index) {
                <div class="sem-geo-map-popup-editor-row">
                  <input
                    type="text"
                    placeholder="Label"
                    [value]="popupFieldValue(fieldIndex, 'name')"
                    (input)="updatePopupField(fieldIndex, 'name', $event)">
                  <input
                    type="text"
                    placeholder="Value"
                    [value]="popupFieldValue(fieldIndex, 'value')"
                    (input)="updatePopupField(fieldIndex, 'value', $event)">
                  <select
                    [value]="popupFieldValue(fieldIndex, 'dataType')"
                    (change)="updatePopupField(fieldIndex, 'dataType', $event)">
                    @for (dataType of popupDataTypes; track dataType) {
                      <option [value]="dataType">{{ dataType }}</option>
                    }
                  </select>
                  <button
                    type="button"
                    class="sem-geo-map-popup-editor-remove"
                    title="Remove field"
                    aria-label="Remove field"
                    (click)="removePopupField(fieldIndex)">
                    <span class="material-symbols-outlined">close</span>
                  </button>
                </div>
              }
            </div>

            <button type="button" class="sem-geo-map-popup-editor-add" (click)="addPopupField()">
              <span class="material-symbols-outlined">add</span>
              <span>Add field</span>
            </button>
          }
        </section>
      }
    </div>

    @if (dataError) {
      <div class="sem-geo-map-message sem-geo-map-message-error">{{ dataError }}</div>
    }
  }
</div>
